// Class-merging helper for shadcn components and local UI.
// `cn()` merges Tailwind class strings and resolves conflicts (e.g. cn("p-2", "p-4") → "p-4").

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
